<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-center">
                <h2 class="display-1 font-weight-bold mb-6">Testimonios</h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-for="(testimonial, index) in testimonials" :key="index" cols="12" md="4">
                <v-card class="pa-4 text-center testimonial-card">
                    <!-- Ícono con inicial -->
                    <v-avatar size="72" color="primary" class="mb-4">
                        <v-icon x-large dark>mdi-alpha-{{ getInitial(testimonial.name) }}-circle</v-icon>
                    </v-avatar>

                    <h3 class="title font-weight-bold">{{ testimonial.name }}</h3>
                    <p class="mb-2 font-italic">"{{ testimonial.comment }}"</p>
                    <v-rating v-model="testimonial.rating" color="amber" dense readonly half-increments
                        size="20"></v-rating>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            testimonials: [
                { name: 'Ana Gómez', comment: 'Excelente servicio y soporte.', rating: 5 },
                { name: 'Carlos Ruiz', comment: 'Innovación y calidad en cada proyecto.', rating: 4.5 },
                { name: 'María López', comment: 'Siempre disponibles cuando los necesitamos.', rating: 5 },
                { name: 'Pedro Molina', comment: 'Profesionales altamente capacitados.', rating: 4 },
                { name: 'Lucía Fernández', comment: 'Resultados superiores a lo esperado.', rating: 5 },
                { name: 'Javier Martínez', comment: 'Cumplen todos los plazos.', rating: 4.5 }
            ]
            // testimonials: [
            //     { name: 'Juan Pérez', avatar: 'mdi-alpha-a-circle', comment: 'Excelente servicio y soporte.' },
            //     { name: 'Ana Gómez', avatar: 'https://via.placeholder.com/150', comment: 'Innovación y calidad en cada proyecto.' },
            //     { name: 'Carlos Ruiz', avatar: 'https://via.placeholder.com/150', comment: 'Siempre disponibles cuando los necesitamos.' },
            // ],
        };
    },
    methods: {
        getInitial(name) {
            // Obtiene la primera letra y la convierte a minúscula
            const initial = name.charAt(0).toLowerCase();
            // Solo usa a-z (para nombres con caracteres especiales usa 'a' como default)
            return /[a-z]/.test(initial) ? initial : 'a';
        }
    }
};
</script>

<style scoped>
.testimonial-card {
    transition: transform 0.3s;
    height: 100%;
}

.testimonial-card:hover {
    transform: translateY(-5px);
}
</style>